import { useWatch } from 'react-hook-form';
import { useCitySuggestions } from '@/apiHooks/geoAutocomplete.hook';
import { useIntl } from '@/i18n';
import { AddressAutocomplete } from './AddressAutocomplete';

export const CityAutocomplete = ({ className }: { className: string }) => {
  const { t } = useIntl();
  const postalCode = useWatch({ name: 'postalCode' });
  const { data, isFetching, isError } = useCitySuggestions(postalCode);
  return (
    <AddressAutocomplete
      name='city'
      label={t({ id: 'benefits.adac.form.city' })}
      className={className}
      disabled={!/^\d{5}$/.test(postalCode)}
      suggestions={data}
      loading={isFetching}
      lookupFailed={isError}
    />
  );
};
